import Tabs from './Tabs';

export type {ITab} from './Tabs';
export default Tabs;
